import {ajax} from "../utils/utils";

export const addCartItem = async (id, quantity = 1, gtm = false) => {
    try {
        //GTM
        if(typeof dataLayer != 'undefined' && gtm){
            dataLayer.push({
                'event': 'add-to-cart',
                'category': 'click',
                'product': gtm
            });
        }
        return new Promise(resolve => {
            ajax('POST', "/cart/add.js", JSON.stringify({
                quantity: quantity,
                id: parseInt(id)
            })).then(function (response) {
                resolve(response);
            });
        });
    } catch (e) {
        console.log('Error adding to cart.', e)
    }
}

/**
 * @param data
 * @param gtm
 * @returns {Promise<unknown>}
 */
export const addCartItemData = async (data, gtm = false) => {
    try {
        //GTM
        if(typeof dataLayer != 'undefined' && gtm){
            dataLayer.push({
                'event': 'add-to-cart',
                'category': 'click',
                'product': gtm
            });
        }
        return new Promise(resolve => {
            ajax('POST', "/cart/add.js", data).then(function (response) {
                resolve(response);
            });
        });
    } catch (e) {
        console.log('Error adding to cart.', e)
    }
}

/**
 * @param line
 * @param gtm
 * @returns {Promise<unknown>}
 */
export const removeCartItem = async (line) => {
    try {
        //GTM
        if(typeof dataLayer != 'undefined'){
            dataLayer.push({
                'event': 'remove-cart-item',
                'category': 'click',
                'line': line
            });
        }
        return new Promise(resolve => {
            ajax('POST', "/cart/change.js", JSON.stringify({
                quantity: 0,
                line: line
            })).then(function (response) {
                resolve(response);
            });
        });
    } catch (e) {
        console.log('Error removing item from cart.', e)
    }
}

export const formatMoney = (amount, decimalCount = 2, decimal = ".", thousands = ",") => {
    try {
        /**
         * Shopify dollar formatter:
         */
        amount = amount.toString().slice(0, -2)
        amount = parseInt(amount)
        /**
         * -------------------------
         */

        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;

        return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
        console.log(e)
    }
};
